export const addresses = {
  snowAddress: "0xa92675Feb3a316d73ec9D8f2A0De7b90b25b1351",
  snowArtAddress: "0x43D045Fea77f674b1AFbfC47d018953Ab02c748a",
};
